module.exports = __webpack_public_path__ + "img/5.37bc6bb9.jpg";